<template>
    <div>
        <LoadingVue :isLoading="isLoading" :key="isLoading"/>
        
        <div :class="view_class_view.div_container" class="grid grid-cols-1">
            <div class="my-2">
                <label for="input_postal_code">Código Postal:</label>
                <input v-maska="'#####'" type="text" id="input_postal_code" name="input_postal_code" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: addressModelValidations.postal_code.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!addressModelValidations.postal_code.$invalid, [view_class_view.class_inputs.default ]: addressModelValidations.postal_code.$invalid && !addressModelValidations.postal_code.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="addressModel.postal_code" @blur="addressModelValidations.postal_code.$validate" @keyup="searsh_suburb()" >
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of addressModelValidations.postal_code.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div class="my-2">
                <label for="input_suburb">Colonia:</label>
                <select id="input_suburb" name="input_suburb" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: addressModelValidations.suburb.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!addressModelValidations.suburb.$invalid, [view_class_view.class_inputs.default ]: addressModelValidations.suburb.$invalid && !addressModelValidations.suburb.$error }"  class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="addressModel.suburb">
                    <option v-for="(suburb, i) in listSuburb" :key="i" :value="suburb.nombre">{{ suburb.nombre }}</option>
                </select>

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of addressModelValidations.suburb.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div class="my-2">
                <label for="input_street">Calle:</label>
                <input type="text" id="input_street" name="input_street" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: addressModelValidations.street.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!addressModelValidations.street.$invalid, [view_class_view.class_inputs.default ]: addressModelValidations.street.$invalid && !addressModelValidations.street.$error }" v-model="addressModel.street">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of addressModelValidations.street.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div class="grid grid-cols-2 my-2">
                <div class="mr-2">
                    <label for="input_external_number">No. Ext:</label>
                    <input id="input_external_number" name="input_external_number" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: addressModelValidations.ext_number.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!addressModelValidations.ext_number.$invalid, [view_class_view.class_inputs.default ]: addressModelValidations.ext_number.$invalid && !addressModelValidations.ext_number.$error }" v-model="addressModel.ext_number">
                    
                    <div :class="view_class_view.div_container_error.container" v-for="(error,index) of addressModelValidations.ext_number.$errors" :key="index">
                        <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                    </div>
                </div>
                <div class="ml-2">
                    <label for="input_internal_number">No. Int:</label>
                    <input id="input_internal_number" name="input_internal_number" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: addressModelValidations.ext_number.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!addressModelValidations.ext_number.$invalid, [view_class_view.class_inputs.default ]: addressModelValidations.ext_number.$invalid && !addressModelValidations.ext_number.$error }" v-model="addressModel.int_number">
                
                    <div :class="view_class_view.div_container_error.container" v-for="(error,index) of addressModelValidations.int_number.$errors" :key="index">
                        <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { ref, toRef, watch } from 'vue';
import useVuelidate from '@vuelidate/core';
import LoadingVue from '../VueLoading.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import { helpers, requiredIf } from "@vuelidate/validators";

export default {
    name: 'IssuanceAddress',
    props: {
        view_class_view: {
            type: Object,
            required: true,
            default(){
                return {
                    class_inputs:{
                        valid:"border-blue-600",
                        no_valid:"border-red-600",
                        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
                    },
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                    div_container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-10",
                }
            }
        },
        validations: {
            type: Object,
            required: true,
            default() {
                return {
                    street: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    suburb: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    ext_number: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    int_number: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    postal_code: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    }
                };
            }
        },
        credentials: {
            type: Object,
            required: true,
            default() {
                return {
                    username_anter_cepomex: "",
                    password_anter_cepomex: ""
                };
            }
        },
        api_url: {
            type: String,
            required: true,
            default() {
                return "";
            }
        }
    },
    setup(props) {

        let listSuburb = ref([]);
        let isLoading = ref(false);
        let addressModel = ref({
            city: "N/A",
            state: "N/A",
            status: "activo",
            street: "",
            suburb: "",
            country: "MÉXICO",
            latitude: "",
            longitude: "",
            ext_number: "",
            int_number: "",
            postal_code: "",
            municipality: "N/A",
        });

        watch( () => addressModel.value.postal_code, () => {
            searsh_suburb();
        });

        const addressModelValidations = useVuelidate(props.validations, addressModel);
        const API_URL = toRef(props, 'api_url');
        const credential_api = toRef(props, 'credentials')

        function searsh_suburb(){
            if(addressModel.value.postal_code.toString().length != 5){
                return;
            }
            
            addressModelValidations.value.postal_code.$validate();
            if(addressModelValidations.value.postal_code.$error){
                return false
            }

            isLoading.value = true;
            const params = {
                contenido: {
                    codigo_postal: addressModel.value.postal_code.toString(),
                    colonia: ""
                }
            };

            const header = {
                headers:{
                    'Content-Type': 'application/json',
                },
                auth: {
                    username: credential_api.value.username_anter_cepomex,
                    password: credential_api.value.password_anter_cepomex,
                }
            }

            axios.post(API_URL.value, params, header).then( response => {

                if(response.data.ERROR){
                    addressModel.value.city = "N/A";
                    addressModel.value.state = "N/A";
                    addressModel.value.municipality = "N/A";
                    listSuburb.value = [];
                    Swal.fire({
                        title: "Aviso",
                        text: "Introduzca un código postal valido",
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });
                    isLoading.value = false;
                    return false;
                }

                addressModel.value.city = response.data.ciudad.nombre != null ? response.data.ciudad.nombre : "N/A";
                addressModel.value.state = response.data.estado.nombre != null ? response.data.estado.nombre : "N/A";
                addressModel.value.municipality = response.data.municipio.nombre != null ? response.data.municipio.nombre : "N/A";
                listSuburb.value = response.data.colonias;
                
            }).catch( error =>{
                console.log(error);
                addressModel.value.city = "";
                addressModel.value.state = "";
                addressModel.value.municipality = "";
                listSuburb.value = [];
                isLoading.value = false;
            }).finally(()=> {isLoading.value = false;});
        }

        function execute_validation() {
            addressModelValidations.value.$validate();
            if(addressModelValidations.value.$error)return null;

            return addressModel.value;
        }

        return {
            isLoading,
            listSuburb,
            addressModel,
            addressModelValidations,
            searsh_suburb,
            execute_validation
        }
    },
    components: {
        LoadingVue
    }
}

</script>